import { render, staticRenderFns } from "./Background.vue?vue&type=template&id=3c089ffb&"
import script from "./Background.vue?vue&type=script&lang=js&"
export * from "./Background.vue?vue&type=script&lang=js&"
import style0 from "./Background.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports